import { Box, Divider, Text } from '@wix/design-system';
import { useTranslation } from '@wix/fe-essentials/react';
import { ElementStatus, RuleFooter } from '@wix/rules-panel-ui';
import { SparklesSmall } from '@wix/wix-ui-icons-common';
import React, { useEffect } from 'react';
import { BiNotificationTypes } from '../../../../../bi/types';
import { useBiLogger } from '../../../../../hooks/use-bi-logger';
import { AltTextScreenAiWarningPopover } from './alt-text-screen-content/alt-text-screen-ai-warning-popover';
import { useAltTextScreenContext } from './alt-text-screen-wrapper';
export const AltTextScreenBottomSection = () => {
  const {
    t
  } = useTranslation();
  const biLogger = useBiLogger();
  const {
    actions: {
      handleClickApply,
      navigateToPanel,
      showBeforeCloseModal
    },
    state: {
      altRulesProps,
      altTextDraftDataMap,
      isLoading,
      showPopoverAiWarning,
      shouldShowModalSaveBeforeClose,
      isGeneratingAltTextSuggestions: isGenerating
    }
  } = useAltTextScreenContext();
  const hasAIGeneratedAltText = altRulesProps.some(_ref => {
    var _altTextDraftDataMap$;
    let {
      id
    } = _ref;
    const status = altTextDraftDataMap == null || (_altTextDraftDataMap$ = altTextDraftDataMap.get(id)) == null ? void 0 : _altTextDraftDataMap$.status;
    return status !== undefined && [ElementStatus.Generated, ElementStatus.GeneratedAll].includes(status);
  });
  useEffect(() => {
    if (hasAIGeneratedAltText) {
      biLogger.notificationView({
        notificationType: BiNotificationTypes.AiCanMakeMistakes
      });
    }
  }, [biLogger, hasAIGeneratedAltText]);
  return /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    flex: "0 0 auto",
    zIndex: "10"
  }, /*#__PURE__*/React.createElement(Divider, null), hasAIGeneratedAltText && /*#__PURE__*/React.createElement(Box, {
    direction: "vertical"
  }, /*#__PURE__*/React.createElement(Box, {
    backgroundColor: "B50",
    direction: "horizontal",
    gap: "SP1",
    padding: "8px 12px"
  }, /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(SparklesSmall, null)), /*#__PURE__*/React.createElement(Text, {
    size: "tiny"
  }, t('accessibility-wizard.alt-text.overview-section.progress-bar.ai-accuracy-warning'))), /*#__PURE__*/React.createElement(Divider, null)), /*#__PURE__*/React.createElement(Box, {
    align: "right",
    padding: "16px 24px"
  }, /*#__PURE__*/React.createElement(RuleFooter, {
    dismissButtonProps: {
      label: t('accessibility-wizard.rules-list.alt-image-rule-fixer.button.cancel'),
      onClick: () => {
        shouldShowModalSaveBeforeClose || isGenerating ? showBeforeCloseModal(navigateToPanel, isGenerating) : navigateToPanel();
      }
    },
    submitButtonProps: {
      disabled: isLoading || isGenerating || altTextDraftDataMap.size === 0,
      label: t('accessibility-wizard.rules-list.alt-image-rule-fixer.button.apply'),
      onClick: async () => {
        await handleClickApply();
      },
      popoverContent: /*#__PURE__*/React.createElement(AltTextScreenAiWarningPopover, null),
      showLoader: isLoading,
      showPopover: showPopoverAiWarning
    }
  })));
};
//# sourceMappingURL=alt-text-screen-bottom-section.js.map